// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
// import Vuetify from 'vuetify';
import VueRouter from 'vue-router';

// import 'vuetify/dist/vuetify.min.css';
import 'babel-polyfill';
import VueCurrencyFilter from 'vue-currency-filter';
import firebase from 'firebase/app';
import VueAnalytics from 'vue-analytics';
import VueGtm from 'vue-gtm';

import App from './App';
import store from './store/store';
import Home from './views/Home';
import Confidence from './views/Confidence';
import Splash from './views/Splash';
import SurveyorsIntro from './views/SurveyorsIntro';
import ChooseLevel from './views/ChooseLevel';
import LevelIntro from './views/LevelIntro';
import Questions from './views/Questions';
import Question from './components/questions/Question';
import Feedback from './components/questions/Feedback';
import Careers from './components/Careers/Listing';
import Career from './components/Careers/Career';
import CompletedLevels from './views/CompletedLevels';
import PursueCareer from './components/PursueCareer';
import GameOverLose from './views/GameOverLose';
import GameOverWin from './views/GameOverWin';

firebase.initializeApp({
  apiKey: 'AIzaSyApMg0mMvV4lamtMqpmPkx_5eFtUKk-DhE',
  authDomain: 'rics-megafutures.firebaseapp.com',
  databaseURL: 'https://rics-megafutures.firebaseio.com',
  projectId: 'rics-megafutures',
});

Vue.config.productionTip = false;
// Routing
const routes = [
  { path: '/', name: 'home', component: Home },
  { path: '/knowledge', name: 'confidence', component: Confidence },
  { path: '/splash', name: 'splash', component: Splash },
  { path: '/surveyors-introduction', name: 'surveyorsIntro', component: SurveyorsIntro },
  { path: '/choose-level', name: 'chooseLevel', component: ChooseLevel },
  { path: '/choose-level/introduction', name: 'levelIntro', component: LevelIntro },
  { path: '/questions',
    name: 'questions',
    component: Questions,
    children: [
      { path: '/questions/question/:id',
        name: 'question',
        component: Question,
      },
      { path: '/questions/feedback/:id',
        name: 'feedback',
        component: Feedback },
    ],
  },
  { path: '/completed-levels', name: 'completedLevels', component: CompletedLevels },
  { path: '/end-survey', name: 'pursueCareer', component: PursueCareer },
  { path: '/game-over', name: 'gameOverLose', component: GameOverLose },
  { path: '/mission-accomplished', name: 'gameOverWin', component: GameOverWin },
  { path: '/explore-careers', name: 'explore-careers', component: Careers },
  { path: '/explore-careers/:id', name: 'career', component: Career },
];
const router = new VueRouter({ routes });

Vue.use(VueRouter);
Vue.use(VueAnalytics, {
  id: 'UA-130197060-1',
  router,
});
Vue.use(VueCurrencyFilter, {
  symbol: '',
  thousandsSeparator: ',',
  fractionCount: 0,
  fractionSeparator: '.',
  symbolPosition: 'front',
  symbolSpacing: false,
});

Vue.use(VueGtm, {
  id: 'GTM-T2KF5QT', // Your GTM ID
  enabled: true,
  debug: true, // Whether or not display console logs debugs (optional)
  vueRouter: router, // Pass the router instance to automatically sync with router (optional)
});

// Vue.http.options.root = 'https://rics-megafutures.firebaseio.com/';

// Filters

// eslint-disable-next-line
Vue.filter('timeInHours', function (value) {
  const hours = parseInt(Math.floor(value / 360), 10);
  const minutes = parseInt(Math.floor((value - (hours * 360)) / 60), 10);
  const seconds = parseInt((value - ((hours * 360) + (minutes * 60))) % 60, 10);
  // eslint-disable-next-line
  const dHours = hours > 9 ? hours : '0' + hours;
  // eslint-disable-next-line
  const dMins = minutes > 9 ? minutes : '0' + minutes;
  // eslint-disable-next-line
  const dSecs = seconds > 9 ? seconds : '0' + seconds;

  // const displayFormat = `${dHours} : ${dMins} : ${dSecs}`;
  // eslint-disable-next-line
  return dHours + ":" + dMins + ":" + dSecs;

  // return displayFormat;
});

/* eslint-disable no-new */
new Vue({
  el: '#app',
  components: { App },
  template: '<App/>',
  router,
  store,
});



// WEBPACK FOOTER //
// ./src/main.js